import React from "react";
import { styled, css } from "styled-components";
import QuasiRadio from "./components/QuasiRadio";
import { DescriptionContainer } from "../OrderDateRadioBox/components/OrderDateRadioBoxBody";
import { Colors } from "../../styles/Colors";
const Container = styled.div `
  position: relative;
  background-color: ${Colors.WHITE};
  box-shadow: inset 0 0 0 1px
    ${({ isChecked }) => (isChecked ? Colors.PROFILE_RED_2024 : Colors.GRAY)};
  border-radius: 5px;
  align-items: ${({ centered }) => (centered ? "center" : "flex-start")};
  width: 100%;
  align-self: flex-start;

  &:hover {
    box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};
    background-color: ${Colors.LIGHT_RED_2024};
    ${QuasiRadio.toString()} {
      background-color: ${Colors.LIGHT_RED_2024};
      box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};
    }

    ${DescriptionContainer.toString()} {
      border-color: ${Colors.WHITE_2024};
    }
  }

  ${({ highlighted }) => highlighted &&
    css `
      box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};
    `}

  ${({ isChecked }) => isChecked &&
    css `
      background-color: ${Colors.LIGHT_RED_2024};
    `}
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    appearance: none;
    border: none;
    background-color: transparent;
  }
`;
const LabelWrap = styled.label `
  width: 100%;
  cursor: pointer;
  &,
  > * {
    cursor: pointer;
  }
`;
export const RadioBox = React.forwardRef(({ body: Body, centered, checked, footer: Footer, header: Header, label, name, onChange, value, highlighted, ...inputProps }, ref) => (React.createElement(Container, { role: "button", "aria-label": label, isChecked: checked, centered: centered, highlighted: highlighted },
    React.createElement(LabelWrap, null,
        React.createElement("input", { type: "radio", name: name, value: value, checked: checked, onChange: onChange, ref: ref, tabIndex: 0, ...inputProps }),
        Header && React.createElement(Header, null),
        Body && React.createElement(Body, null),
        Footer && React.createElement(Footer, null)))));
export default RadioBox;
//# sourceMappingURL=RadioBox.js.map